/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

// Debe ejecutarse antes de montar React: parchea removeChild/insertBefore para
// tolerar mutaciones del DOM hechas por la traducción del navegador o extensiones.
import "./tools/domTranslationGuard";

import { createRoot } from "react-dom/client";
import { UserProvider } from "./context/UserContext";
import { ToastProvider } from "./context/ToastContext";
import { ServiceProvider } from "./context/ServiceContext";
import AppRoutes from "./AppRoutes";

function start() {
  const root = createRoot(document.getElementById("root")!);
  root.render(
    <UserProvider>
      <ToastProvider>
        <ServiceProvider>
          <AppRoutes />
        </ServiceProvider>
      </ToastProvider>
    </UserProvider>
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
